import { render, staticRenderFns } from "./createMiniProgram.vue?vue&type=template&id=993f7ec4&scoped=true"
import script from "./createMiniProgram.vue?vue&type=script&lang=js"
export * from "./createMiniProgram.vue?vue&type=script&lang=js"
import style0 from "./createMiniProgram.vue?vue&type=style&index=0&id=993f7ec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993f7ec4",
  null
  
)

export default component.exports